import React, { useState } from 'react';
import { useApi } from '../../hooks/useApi';
import { askAITutor } from '../../services/api';
import './AITutorPanel.css';

const AITutorPanel = ({ screenContent, lessonTopic, subjectArea, lessonId, screenId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleRequest } = useApi();

  const handleAskQuestion = async () => {
    if (!question.trim() || !lessonId || !screenId) return;

    setLoading(true);
    setAnswer('');
    try {
      const response = await handleRequest(askAITutor, lessonId, {
        question: question.trim(),
        screenId
      });
      setAnswer(response.data.answer || 'Sorry, I could not generate an answer.');
    } catch (error) {
      setAnswer('Sorry, I encountered an error. Please try again.');
      console.error('AI Tutor error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`ai-tutor-panel ${isOpen ? 'open' : ''}`}>
      <button
        className="tutor-toggle-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '✕' : '💬'} Spørsmål? Spør om hjelp her
      </button>

      {isOpen && (
        <div className="tutor-content">
          <h3>Still et spørsmål</h3>
          <p className="tutor-context">
            Still et spørsmål om dette: <strong>{screenContent?.substring(0, 50)}...</strong>
          </p>
          
          <div className="tutor-input-area">
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Hva vil du vite om dette emnet?"
              rows="3"
              className="tutor-textarea"
            />
            <button
              className="ask-button"
              onClick={handleAskQuestion}
              disabled={loading || !question.trim()}
            >
              {loading ? 'Ber om hjelp...' : 'Spør om hjelp'}
            </button>
          </div>

          {answer && (
            <div className="tutor-answer">
              <strong>Answer:</strong>
              <p>{answer}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AITutorPanel;
